import { Lightning } from '@lightningjs/sdk'

import { getColor, grey50, grey960, transparent } from '../../constants/colors'
import { BORDER_RADIUS } from '../../constants/general'
import { TvCardStyle, TvCardType } from '../../types/flo-enums'
import { CardItemModel } from '../../types/flo-experience'
import { CARD_SPACING, getCardSize } from '../../utils/carouselUtils'
import SpeechComp from '../speechComp/speechComp'

export const FOCUS_BORDER_WIDTH = 8
const MID_BORDER_WIDTH = 4
export default class TvCard extends SpeechComp {
  private _data: CardItemModel
  private _style: TvCardStyle
  private _cardType: TvCardType
  private _rowIndex = 0
  private _cardIndex = 0
  private _totalCards = 0

  static _template() {
    return {
      h: (h) => h,
      w: (w) => w,
      collision: true,
      flexItem: {
        marginRight: CARD_SPACING,
      },
      FocusBorder: {
        w: (w) => w + FOCUS_BORDER_WIDTH * 2,
        h: (h) => h + FOCUS_BORDER_WIDTH * 2,
        x: -FOCUS_BORDER_WIDTH,
        y: -FOCUS_BORDER_WIDTH,
        rect: true,
        zIndex: 1,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          stroke: FOCUS_BORDER_WIDTH,
          strokeColor: transparent,
          fillColor: transparent,
          radius: BORDER_RADIUS,
        },
      },
      MidBorder: {
        w: (w) => w + MID_BORDER_WIDTH * 2,
        h: (h) => h + MID_BORDER_WIDTH * 2,
        x: -MID_BORDER_WIDTH,
        y: -MID_BORDER_WIDTH,
        rect: true,
        zIndex: 1,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          stroke: 4,
          strokeColor: transparent,
          fillColor: transparent,
          radius: BORDER_RADIUS,
        },
      },
      Container: {
        w: (w) => w,
        h: (h) => h,
      },
    }
  }

  get container() {
    return this.tag('Container')
  }

  set data(v) {
    this._data = v
  }

  get data() {
    return this._data
  }

  set style(v) {
    this._style = v
  }

  get style() {
    return this._style
  }

  set cardType(v) {
    this._cardType = v
  }

  get cardType(): TvCardType {
    return this._cardType
  }

  get cardHeight() {
    return getCardSize(this.cardType, this.style)?.h
  }

  get cardWidth() {
    return getCardSize(this.cardType, this.style)?.w
  }

  set rowIndex(v) {
    this._rowIndex = v
  }

  get rowIndex() {
    return this._rowIndex
  }

  set cardIndex(v) {
    this._cardIndex = v
  }

  get cardIndex() {
    return this._cardIndex
  }

  get totalCards() {
    return this._totalCards
  }

  set totalCards(v: number) {
    this._totalCards = v
  }

  _focus() {
    this.patch({
      FocusBorder: {
        shader: {
          strokeColor: getColor(grey50),
        },
      },
      MidBorder: {
        shader: {
          strokeColor: getColor(grey960),
        },
      },
    })
    this.speak()
  }

  _unfocus() {
    this.patch({
      FocusBorder: {
        shader: {
          strokeColor: transparent,
        },
      },
      MidBorder: {
        shader: {
          strokeColor: transparent,
        },
      },
    })
  }

  _handleHover() {
    this.fireAncestors('$updateFocusByHover', this)
    this._focus()
  }

  _handleUnhover() {
    this._unfocus()
  }
}
